import { render, staticRenderFns } from "./data-view-management.vue?vue&type=template&id=b024ebf4&scoped=true&"
import script from "./data-view-management.vue?vue&type=script&lang=js&"
export * from "./data-view-management.vue?vue&type=script&lang=js&"
import style0 from "./data-view-management.vue?vue&type=style&index=0&id=b024ebf4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b024ebf4",
  null
  
)

export default component.exports